import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right-circle",
  "use": "icon-arrow-right-circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow-right-circle\">\n<path fill=\"\" d=\"M22 12L13 4V9C13 9 5.33999 8.5 3.14999 13.3C1.54999 16.6 2.04999 19.2 2.14999 19.6C2.11999 19.48 2.64999 18.93 2.72999 18.82C2.94999 18.54 3.18999 18.27 3.42999 18C3.90999 17.48 4.42999 17 4.98999 16.57C5.79999 15.95 6.71999 15.45 7.70999 15.18C8.79999 14.89 9.91999 15 11.04 15C11.69 15 12.35 15 13 15V20L22 12Z\" undefined=\"1\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol